import axios from "axios";

const fetchSponsorsDetails = async (sponsorId) => {
    const sponsorResponse = await axios.get(
        `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislators/${sponsorId}`
    );
    return sponsorResponse.data;
};

export default fetchSponsorsDetails;